import { HorizontalAlignment, VerticalAlignment } from '../../shared.enums';
import { IslandType } from '../../islands/enums';
import { PADDING_BY_MATERIAL, STANDARD_ISLAND_PADDING } from '../../surround-material/constants';
import { Panel } from '../panel.class';
import { Size } from '../../../types';

export const newIslandCfn = (panel: Panel, params: { islandType: IslandType, size: Size }): void => {
	const { islandType, size } = params;

	if (islandType === IslandType.Corner && !panel.isSidePanel) {
		// eslint-disable-next-line no-alert
		alert('Corner Islands can only be attached to side panels.');
		return;
	}

	const island = panel.refMap.kitchen.design.islands.newIsland(islandType, size);
	const baseFinish = panel.refMap.kitchen?.material?.surround?.material ?? '';
	const padding = PADDING_BY_MATERIAL[baseFinish] ?? STANDARD_ISLAND_PADDING;

	let sourceAlign = panel.isLeftPanel ? HorizontalAlignment.left : HorizontalAlignment.right;
	let targetAlign = panel.isLeftPanel ? HorizontalAlignment.right : HorizontalAlignment.left;
	let sourcePanelId = panel.isLeftPanel ? island.frontPanel.connections.right.targetPanelId : island.frontPanel.connections.left.targetPanelId;
	let sourcePanel = island.panels.findById(sourcePanelId);
	let sourceAngle = (sourcePanel.getOriginAngle() - panel.getOriginAngle() + 180 + panel.refMap.island.axis.y) % 360;
	// console.log(`panelAngle (${sourceAngle}) = (${sourcePanel.getOriginAngle()} - ${panel.getOriginAngle()} + 180 + ${panel.refMap.island.position.rotation.y}) % 360`);

	if (island.type === IslandType.Corner) {
		island.axis.y = sourceAngle;

		island.connections.newConnection(
			// eslint-disable-next-line max-len
			{ panelId: sourcePanelId, islandId: island.id, verticalAlignment: VerticalAlignment.bottom, horizontalAlignment: sourceAlign },
			{ panelId: panel.id, islandId: panel.refMap.island.id, verticalAlignment: VerticalAlignment.bottom, horizontalAlignment: targetAlign },
			{ padding, offset: 0 }
		);
	} else {
		if (!panel.isSidePanel) {
			sourceAlign = panel.isFrontPanel ? HorizontalAlignment.right : HorizontalAlignment.left;
			targetAlign = panel.isFrontPanel ? HorizontalAlignment.left : HorizontalAlignment.right;
			sourcePanelId = panel.isFrontPanel ? island.frontPanel.connections.right.targetPanelId : island.frontPanel.connections.left.targetPanelId;
			sourcePanel = island.panels.findById(sourcePanelId);
			sourceAngle = (sourcePanel.getOriginAngle() - panel.getOriginAngle() + 180 + panel.refMap.island.axis.y) % 360;
			// eslint-disable-next-line max-len
			// console.log(`updated panelAngle (${sourceAngle}) = (${sourcePanel.getOriginAngle()} - ${panel.getOriginAngle()} + 180 + ${panel.refMap.island.position.rotation.y}) % 360`);
		}
		island.axis.y = sourceAngle;
		island.connections.newConnection(
			// eslint-disable-next-line max-len
			{ panelId: sourcePanelId, islandId: island.id, verticalAlignment: VerticalAlignment.bottom, horizontalAlignment: sourceAlign },
			{ panelId: panel.id, islandId: panel.refMap.island.id, verticalAlignment: VerticalAlignment.bottom, horizontalAlignment: targetAlign },
			{ padding, offset: 0 }
		);
	}

	panel.refMap?.kitchen.design.countertops.new(island.id);
};
